import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";
import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    cartPage: {
        maxWidth: "1044px",
        margin: "0 auto 77px auto",
        padding: theme.spacing(0, 3),
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
            padding: theme.spacing(0, 2),
        },
    },
}));
